import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Common from "../../helpers/common";
import { respEnum } from "../../constants/appConstants";
import Swal from "sweetalert2";

const changePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
  confirmPassword: Yup.string()
    .required("Please confirm your password")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});

const ChangePasswordModal = ({ onClose, verificationId, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      await Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "New password and confirm password do not match",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
      return;
    }

    setIsLoading(true);
    try {
      Common.ApiService.getInstance().initialize(
        Common.AppConstant.serviceUrl,
        {
          "Content-Type": "application/json",
        }
      );

      const response = await Common.ApiService.getInstance()?.request(
        "UpdatePassword",
        {
          newPassword: values.newPassword,
          vCodeId: verificationId,
        },
        "POST"
      );

      if (response?.status == respEnum.Success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Password updated successfully",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
        onSuccess?.();
        onClose();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Failed to update password",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update password. Please try again.",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup">
      <div
        className="popup-inner"
        style={{
          backgroundColor: "#1a1a1a",
          color: "white",
          top: "50%",
          border: "1px solid",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.1)",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "28px",
            cursor: "pointer",
            padding: "5px 10px",
            lineHeight: "1",
            zIndex: "1000",
          }}
        >
          ×
        </button>

        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <img
            src="/images/logo_white.svg"
            alt="Ignite Sports"
            style={{
              width: "120px",
              height: "auto",
            }}
          />
        </div>

        <h2
          style={{
            textAlign: "center",
            color: "white",
            marginBottom: "6px",
            fontSize: "28px",
            fontWeight: "bold",
          }}
        >
          Change Password
        </h2>

        <p
          style={{
            textAlign: "center",
            color: "#999",
            marginBottom: "20px",
            fontSize: "14px",
          }}
        >
          Enter your new password
        </p>

        <Formik
          initialValues={{
            newPassword: "",
            confirmPassword: "",
          }}
          validationSchema={changePasswordSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    color: "#999",
                    marginBottom: "8px",
                    display: "block",
                    fontSize: "14px",
                  }}
                >
                  NEW PASSWORD
                </label>
                <input
                  type="password"
                  name="newPassword"
                  value={formikProps.values.newPassword}
                  onChange={formikProps.handleChange}
                  onBlur={formikProps.handleBlur}
                  placeholder="New Password"
                  style={{
                    width: "100%",
                    padding: "4px",
                    backgroundColor: "#2d2d2d",
                    border: "1px solid #3d3d3d",
                    borderRadius: "4px",
                    color: "white",
                    fontSize: "16px",
                  }}
                />
                {formikProps.touched.newPassword &&
                  formikProps.errors.newPassword && (
                    <div
                      style={{
                        color: "#ff4d4d",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {formikProps.errors.newPassword}
                    </div>
                  )}
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    color: "#999",
                    marginBottom: "8px",
                    display: "block",
                    fontSize: "14px",
                  }}
                >
                  CONFIRM PASSWORD
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formikProps.values.confirmPassword}
                  onChange={formikProps.handleChange}
                  onBlur={formikProps.handleBlur}
                  placeholder="Confirm Password"
                  style={{
                    width: "100%",
                    padding: "4px",
                    backgroundColor: "#2d2d2d",
                    border: "1px solid #3d3d3d",
                    borderRadius: "4px",
                    color: "white",
                    fontSize: "16px",
                  }}
                />
                {formikProps.touched.confirmPassword &&
                  formikProps.errors.confirmPassword && (
                    <div
                      style={{
                        color: "#ff4d4d",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {formikProps.errors.confirmPassword}
                    </div>
                  )}
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  width: "100%",
                  backgroundColor: "white",
                  color: "black",
                  marginTop: "25px",
                  padding: "4px",
                  borderRadius: "4px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#e6e6e6")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
              >
                {isLoading ? "Updating..." : "Update Password"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
